import {Component, EventEmitter, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {__usernameOrEmail} from '../../../directives/validators/sts-conditional-email-validator.directive';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsRegexBluePrintModel} from '../../../models/sts-regex-blue-print.model';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsTfaRegServiceService} from '../../../services/sts-tfa-reg-service.service';
import {StsUserService} from '../../../services/sts-user.service';
import {StsUser} from '../../../models/sts-user.model';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';


@Component({
  selector: 'app-account-reg-pick-user-name',
  templateUrl: './account-reg-pick-user-name.component.html',
  styleUrls: ['./account-reg-pick-user-name.component.scss']
})
export class AccountRegPickUserNameComponent implements OnInit {

  public model: StsA360RegStep2UsernamePostModel = new StsA360RegStep2UsernamePostModel();
  public errors: StsNotification[] = [];
  public signUpForm: FormGroup;
  public canPickUsernameToo = false;
  public tenantInfo: StsTenant = new StsTenant();
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public emailIsValid = true;
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public changeUserId: Boolean = false;
  public linkFromEmail: Boolean = false;
  message: StsA360NotificationTokenModel;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private userService: StsUserService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private router: Router) {
    this.route.params.subscribe(params => {
      this.changeUserId = params['changeUserId'] === 'true';
      this.linkFromEmail = params['linkFromEmail'] === 'true';

      this.tenantService.getTenantSource().subscribe(tenant => {
        this.tenantInfo = tenant;
        //TODO:
        // this is a temperory fix since originaly this imp was not backward compatible
        // if its undefined then we set it as true , otherwise the data should come from backend
        // backend should manage this,
        if (tenant.allowUsernameAsUniqueId === undefined) tenant.allowUsernameAsUniqueId = true;
        this.canPickUsernameToo = tenant.allowUsername && tenant.allowUsernameAsUniqueId;

        this.portalStatusService.getPortalStatus().subscribe(
          (portalStatus: StsPortalStatus) => {
            let isSelfRegFlow = portalStatus.isSelfRegFlow;

            if ((!params['id'] || !isSelfRegFlow) && !(params['linkFromEmail'] === 'true')) {
              console.log('User attempting to execute \'set username\' without permission! Redirecting to login.');
              this.router.navigateByUrl('/account/signin');
              return;
            }
            this.model = new StsA360RegStep2UsernamePostModel();
            this.model.id = params['id'];
            if (params['linkFromEmail'] === 'true') {
              regService.getPersonalEmail(params['id']).subscribe(rs => {
                  if (rs.errors === undefined || rs.errors.length === 0) {
                    let fc = this.signUpForm.controls['emailInput'] as FormControl;
                    fc.setValue(rs.info.personalEmail);
                    this.model.id = rs.info.id;
                  } else {
                    let err = new StsNotification();
                    let e = rs.errors[0];
                    err.code = rs.errors[0];
                    err.description = rs.errors[0];
                    err.level = StsNotificationType.Error;
                    this.errors = [err];
                  }
                }
              );
            } else {
              if (this.message.PersonalEmail) {
                let fc = this.signUpForm.controls['emailInput'] as FormControl;
                fc.setValue(this.message.PersonalEmail);
              }
            }
          });
      });

      this.signUpForm = this.fb.group({
        mode: ['email'],
        usernameInput: new FormControl('',
          {
            validators: [
              (c: FormControl) => {
                if (this.getMode() !== 'username') {
                  return null;
                }
                if (!c.value) {
                  return {
                    usernameRequired: {
                      valid: false
                    }
                  };
                }
              },
              __usernameOrEmail('username', () => this.getMode())
            ],
            updateOn: 'submit'
          }),
        emailInput: new FormControl('',
          {
            validators: [
              (c: FormControl) => {
                if (this.getMode() !== 'email') {
                  return null;
                }
                if (!c.value) {
                  return {
                    emailRequired: {
                      valid: false
                    }
                  };
                }
                let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
                re = re.replace(/(^\\A)|(\\Z$)/g, '');
                this.emailIsValid = (new RegExp(re)).test(c.value);
                return (new RegExp(re)).test(c.value) ? null : {
                    validateEmail: {
                      valid: false
                    }
                  };
              },
              __usernameOrEmail('email', () => this.getMode())],
            // asyncValidators: [__uniqueEmailValidator(this.regService, this.model.id)],
            updateOn: 'submit'
          })
      });

      this.signUpForm.controls['mode'].valueChanges.subscribe(b => {
        this.resetFields();
      });

    });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {
    if (this.canPickUsernameToo) {
      this.signUpForm.controls['usernameInput'].updateValueAndValidity();
    }
    this.signUpForm.controls['emailInput'].updateValueAndValidity();
  }

  public resetFields() {
    if (this.canPickUsernameToo) {
      this.signUpForm.controls['usernameInput'].reset();
    }
    this.signUpForm.controls['emailInput'].reset();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getReType(re: string): StsRegexBluePrintModel {
    let tmp = new StsRegexBluePrintModel();
    re = re.replace(/(^\\A)|(\\Z$)/g, '');
    tmp.regexp = new RegExp(btoa(re));
    tmp.model = this.model;
    return tmp;
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmit(): void {
    // console.log(this.getMode(), this.emailIsValid);
    this.submitter.emit(false);
    this.triggerValidation('');
    if (this.signUpForm.valid) {
      this.submitter.emit(true);
      this.errors = [];
      let m = this.signUpForm.controls['mode'].value === 'username';
      let n = new StsA360RegStep2UsernamePostModel();
      n.id = this.model.id;
      let user = new StsUser();
      user.id = n.id;
      if (m) {
        n.username = this.signUpForm.controls['usernameInput'].value;
        this.message.UserName = n.username;
        this.regService.changeMessage(this.message);
      } else {
        n.email = this.signUpForm.controls['emailInput'].value;        
        this.message.PersonalEmail = n.email;
        this.regService.changeMessage(this.message);
      }
      if (this.changeUserId) { // update user in ariel security db
        if (n.username) user.hasEmailChanged = false;
        if (n.email) user.hasEmailChanged = true;

        user.userName = n.username || n.email;
        this.userService.changeUserId(user).subscribe(data => {
          this.submitter.emit(false);
          if (data.success) {
            let url = '/account/forgot-username/';
            this.router.navigate([url, {newUserName: user.userName, userId: user.id}]);
          }
          else {// something went wrong in back-end
            let e = new StsNotification();
            e.code = 'sts-failed-udpate-username';
            e.level = StsNotificationType.Error;
            e.description = 'an error occured while updating your username';
            this.errors = [e];
          }
        });
      } else { // register a new user in ariel360
        this.regService.postStep2Answers(n).subscribe(rs => {
          this.submitter.emit(false);
          if (rs.success) {
            //We can reach this point without an email on file. So in this case. 
            //We will check if an email or personal email exists on file. 
            //If it does not. Then we will need to route to the email collection component.             
            if(!(this.message.Email || this.message.PersonalEmail || n.email) && !this.tenantInfo.isUseEmailOnFileForRegistrationEnabled && this.tenantInfo.isEmailCollectionEnabled){             
              this.router.navigateByUrl('/account/collect/email/' + user.id + '/false/false');
            }
            //tenant has 2fa
            else if (this.tenantInfo.isTfaEnabled) {
              let channel = this.tenantInfo.tfaPreferredMode;
              //2 channels are defined for the tenant
              if (this.tenantInfo.tfaDeliveryChannels && this.tenantInfo.tfaDeliveryChannels.length > 1 && this.tenantInfo.tfaDeliveryChannels.includes('SMS')) {
                this.router.navigateByUrl('/account/reg/sel-comm/' + user.id);
                return;
              }
              else {
                if (this.tenantInfo.tfaDeliveryChannels) {
                  channel = this.tenantInfo.tfaDeliveryChannels.includes('SMS') ? 'phone' : channel;
                }
                this.message.PreferredChannel = channel;
                this.regService.changeMessage(this.message);
              }

              let address = channel === 'phone' ? this.message.Phone : (n.email ? n.email : this.message.PersonalEmail);
              
              //If we have changed the email address then we need to update the message service as well
              if(!m && this.message.PersonalEmail != n.email)
              {
                this.message.PersonalEmail = n.email;
                this.regService.changeMessage(this.message);
              }

              this.tfa.sendValidationEmail(channel, address).subscribe(a => {
                  if (a.success) {
                    this.router.navigateByUrl('/account/validate/email/' + user.id);
                  } else {
                    if (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail') {
                      let e = new StsNotification();
                      e.code =  a.stsCode || 'sts-failed-tfa-email';
                      e.level = StsNotificationType.Error;
                      e.description = 'An error occurred while validating your email';
                      this.errors = [e];
                    }
                    else {
                      if (this.message.PreferredChannel == "phone") {
                        let e = new StsNotification();
                        e.code =  a.stsCode || 'sts-failed-tfa-email-phone';
                        e.level = StsNotificationType.Error;
                        e.description = 'an error occured while validating your phone';
                        this.errors = [e];
                      }
                      else {
                        let e = new StsNotification();
                        e.code = rs['sts-code'] || a.stsCode;
                        e.level = StsNotificationType.Error;
                        e.description = 'Submitted data contains errors';
                        this.errors = [e];
                      }
                    }
                  }
                });
            } else {
              this.router.navigate(['/account/password/new', { id: user.id }]);
            }
          } else {
            let e = new StsNotification();
            e.code = rs['sts-code'] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = 'Submitted data contains errors';

            if (e.code === 'sts-invalid-email'
              && (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail')
              && !this.message.Email
              && !this.message.PersonalEmail
              && this.message.Phone
            ) {
              e.code = "STS_LOGIN_FAILED";
            }

            this.errors = [e];
          }
        });
      }
    } else {
      let e = new StsNotification();
      e.code = 'sts-correct-username-errors';
      e.level = StsNotificationType.Error;
      e.description = 'submitted data contains errors';
      this.errors = [e];
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getMode(): string {
    if (!this.signUpForm || !this.canPickUsernameToo) {
      return '';
    }
    return this.signUpForm.get('mode').value;
  }

  onSignupModeChanged = (evt) => {
    this.signUpForm.controls['mode'].setValue(evt.target.value);
  }

}

